export const data7_3_default = [{
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: '',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}, {
    title: 'Total',
    level: "",
    vacant_since: "",
    no_employee: "0",
    internal_develop_plan: "",
    recruit_channel: "",
    plan_action: "",
    remarks: "",
}];


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-3/data.js